export const PAGES_BANNER_INFO = [
	{
		path: "/",
		title: "dashboard.title",
		description: "dashboard.description",
	},
	{
		path: "/users",
		title: "userAccounts.usersList.title",
		description: "userAccounts.usersList.description",
	},
	{
		path: "/roles",
		title: "userAccounts.rolesAndPrivileges.title",
		description: "userAccounts.rolesAndPrivileges.description",
	},
	{
		path: "/employees",
		title: "employees.employeesList.title",
		description: "employees.employeesList.description",
	},
	{
		path: "/vacancies",
		title: "employees.vacancies.title",
		description: "employees.vacancies.description",
	},
	{
		path: "/vacancy",
		title: "employees.newVacancy.title",
		description: "employees.newVacancy.description",
	},
	{
		path: "/pages",
		title: "websiteContent.sites.title",
		description: "websiteContent.sites.description",
	},
	{
		path: "/page",
		title: "websiteContent.site.title",
		description: "websiteContent.site.description",
	},
	{
		path: "/gallery",
		title: "websiteContent.gallery.title",
		description: "websiteContent.gallery.description",
	},
	{
		path: "/documents",
		title: "websiteContent.documents.title",
		description: "websiteContent.documents.description",
	},
	{
		path: "/pricelist",
		title: "websiteContent.priceList.title",
		description: "websiteContent.priceList.description",
	},
	{
		path: "/notifications",
		title: "websiteContent.notifications.title",
		description: "websiteContent.notifications.description",
	},
	{
		path: "/articles",
		title: "articles.allArticles.title",
		description: "articles.allArticles.description",
	},
	{
		path: "/article",
		title: "articles.article.title",
		description: "articles.article.description",
	},
	{
		path: "/new-article",
		title: "articles.newArticle.title",
		description: "articles.newArticle.description",
	},
	{
		path: "/events",
		title: "events.allEvents.title",
		description: "events.allEvents.description",
	},
	{
		path: "/event",
		title: "events.event.title",
		description: "events.event.description",
	},
	{
		path: "/new-event",
		title: "events.newEvent.title",
		description: "events.newEvent.description",
	},
	{
		path: "/products",
		title: "products.allProducts.title",
		description: "products.allProducts.description",
	},
	{
		path: "/product",
		title: "products.product.title",
		description: "products.product.description",
	},
	{
		path: "/new-product",
		title: "products.newProduct.title",
		description: "products.newProduct.description",
	},
	{
		path: "/orders",
		title: "orders.allOrders.title",
		description: "orders.allOrders.description",
	},
	{
		path: "/profile",
		title: "profile.title",
		description: "profile.description",
	},
	{
		path: "/settings",
		title: "settings.title",
		description: "settings.description",
	},
];
